import '../Styles/Footer.css';
export function MainFooter(){
    return(
        <div >
        </div>
    )
}